export const FIREBASE_REGISTER_ERROR = {
  "Firebase: Error (auth/email-already-in-use).": "Email already in use",
};
